import { useQuery } from 'react-query';

import { AgencyQuickReplyDto } from '@bandido/shared/dtos';
import { client } from '@frontend/features/common/services';
import { QueryKeys } from '@frontend/features/common/types';

const fetchQuickReplies = async (agencyId: number): Promise<AgencyQuickReplyDto[]> => {
  const { data } = await client.get(`/whatsapp/quick-replies/${agencyId}`);
  return data;
};

export const useGetQuickReplies = (agencyId?: number) =>
  useQuery(
    [QueryKeys.getWhatsappQuickReplies, agencyId],
    () => fetchQuickReplies(agencyId as number),
    {
      enabled: Boolean(agencyId),
      refetchOnWindowFocus: false,
    },
  );
